import { prefixes, prependIntlIds } from "../../utils";

const unprefixedVersionTableHeaderMessages = {
  isActive: "Active",
  version: "Version",
  savedDatetime: "Saved at",
  name: "Name",
  creatorUsername: "Created by",
};

export default prependIntlIds(
  prefixes.versionTableHeader,
  unprefixedVersionTableHeaderMessages
);
